<template>
  <div style="height:100%">
    <BaseContainer style="height:100%">
      <el-card class="box-card" style="height: 100%" shadow="always">
        <div>
          <i class="iconfont icon-system-setting" style="font-size: 16px"><span class="ml-1"
              style="font-size: 12px"><strong>{{ $t("common.profit_setting") }}</strong></span></i>
        </div>

        <div class="ml-1 mt-2">
          {{ $t("common.min") }}:
          <el-input style="width: 150px" class="mr-2" type="number" v-model="minProfit">
          </el-input>
          {{ $t("common.max") }}:
          <el-input style="width: 150px" class="ml-2" type="number" v-model="maxProfit">
          </el-input>

        </div>

        <div class="ml-1 mt-3">
          <i class="iconfont icon-system-setting" style="font-size: 16px"><span class="ml-1"
              style="font-size: 12px"><strong>{{ $t("common.target_profit_setting") }}</strong></span></i>
        </div>

        <div class="ml-1 mt-2">
          {{ $t("common.target_profit") }}:
          <el-input style="width: 150px" class="mr-2" type="number" v-model="TargetProfit">
          </el-input>
        </div>

        <QueryButton :type="'success'" :iconClass="'iconfont icon-save'" :size="'mini'" @on_query="saveData"
          :label="$t('common.save')" class="mt-2">
          &nbsp;{{ $t('common.save') }}</QueryButton>
      </el-card>
    </BaseContainer>
  </div>
</template>

<script>
import * as SystemSettingController from "../../controllers/system/SystemSettingController"
import BaseContainer from "../components/BaseContainer"
import QueryButton from "../components/base/QueryButton"
import TestQueryPanel from "../components/base/TestQueryPanel"

export default {
  name: "PropertyManage",
  components: {
    BaseContainer,
    TestQueryPanel,
    QueryButton,
  },
  data() {
    return {
      methods: SystemSettingController.methods,
      minProfit: 0,
      maxProfit: 0,
      profit_id: "",
      TargetProfit: 0
    }
  },
  watch: {},
  created() {
    this.GetData()
  },
  methods: {
    //数据检测
    async validData() {
      if (this.minProfit == "" || this.minProfit < 0) {
        this.msgToasts(this.$t("common.min_not_null_or_empty"), "info")
        return false
      }
      if (this.maxProfit == "" || this.maxProfit < 0) {
        this.msgToasts(this.$t("common.max_not_null_or_empty"), "info")
        return false
      }
      if (this.minProfit >= this.maxProfit) {
        this.msgToasts(this.$t("common.min_must_less_max"), "info")
        return false
      }
      if (this.TargetProfit == "" || !this.TargetProfit) {
        this.msgToasts(this.$t("common.input") + this.$t("common.target_profit"), "info")
        return false
      }
      return true
    },
    async saveData(cb) {
      if (!(await this.validData())) {
        cb(false)
        return
      }
      let _params = {}
      _params.setting_value = JSON.stringify({
        minProfit: this.minProfit,
        maxProfit: this.maxProfit,
        TargetProfit: this.TargetProfit,
      })
      _params.code = "profit_setting"
      _params.id = this.profit_id
      let result = await this.methods.SaveData(_params)
      //
      if (result) {
        this.msgToasts(this.$t("notify.action_successfully"), "success")
        this.profit_id = result[0][0].id
        cb(true)
      } else {
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "info")
        cb(false)
      }
    },
    async GetData() {
      let result = await this.methods.GetData({ code: { "=": "profit_setting" } })
      //
      if (result[0].length < 1) {
        return
      } else {
        this.profit_id = result[0][0].id
        let str = result[0][0].setting_value ? JSON.parse(result[0][0].setting_value) : {}
        this.minProfit = str.minProfit
        this.maxProfit = str.maxProfit
        this.TargetProfit = str.TargetProfit
      }
    },
  },
}
</script>
<style></style>
